import { render, staticRenderFns } from "./MarkdownPanel.vue?vue&type=template&id=3453f6be"
import script from "./MarkdownPanel.vue?vue&type=script&lang=js"
export * from "./MarkdownPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports